import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { styles, dateTimeTranslate } from 'yankees-react-utils';
import { Container, Col, Row } from 'react-bootstrap';
import ImageProtectedDisplay from './ImageProtectedDisplay';
import VideoProtectedDisplay from './VideoProtectedDisplay';
import ReportCard from './ReportCard';

const StyledReportNotes = styled(Container)`
    && p {
        margin: 0.25em 0;
    }
`;
const StyledImgVideoContainer = styled.div`
    max-height: 700px;
    max-width: 700px;
    margin: auto;
    text-align: center;
    ${(props) => (props.hasVideo ? 'cursor: pointer;' : '')}
    img {
        max-height: 700px;
        max-width: 100%;
    }
`;
const StyledNoteInfo = styled.div`
    text-align: right;
    color: ${styles.theme.fontColors.silverChalice};
    font-style: italic;
    font-size: 0.8em;
    white-space: nowrap;
`;

const TippingPlayer = ({ data, playerId, showNoneIfNoTippingNotes }) => {
    const { t: translate } = useTranslation();
    const tipTypeClass = { 2: 'light-yellow-bg', 3: 'light-green-bg', 4: 'light-red-bg' };

    return (
        <div>
            {data && (
                <>
                    {Object.keys(data).length > 0 && (
                        <StyledReportNotes fluid>
                            {data.map((n) => (
                                <div className={tipTypeClass[n.TipType]} key={`${n.PitchTipNoteID}_div`}>
                                    <ReportCard key={`${n.PitchTipNoteID}_rc`} title={n.Title} titleIsHtml>
                                        <React.Fragment key={n.PitchTipNoteID}>
                                            <Row className="align-items-center">
                                                <Col sm={12} xl={4} dangerouslySetInnerHTML={{ __html: n.Notes }} />
                                                {(n.AttachmentID || n.PlayerVideoID) && (
                                                    <Col sm={12} xl={8}>
                                                        <StyledImgVideoContainer>
                                                            {n.AttachmentID && !n.PlayerVideoID && <ImageProtectedDisplay imgurl={`/api/pitchtipping/${playerId}/attachment/${n.AttachmentID}`} alt={n.AttachmentFilename} style={{ maxWidth: '75%' }} />}
                                                            {n.PlayerVideoID
                                                                    && (
                                                                        <VideoProtectedDisplay
                                                                            videourl={`/api/playervideo/${n.PlayerVideoID}/stream/${n.PlayerVideoFilename}`}
                                                                            alt={n.AttachmentFilename}
                                                                            style={{ maxWidth: '100%' }}
                                                                            mime={n.PlayerVideoMimeType}
                                                                            controls
                                                                        />
                                                                    )}
                                                        </StyledImgVideoContainer>
                                                    </Col>
                                                )}
                                            </Row>
                                        </React.Fragment>
                                        <StyledNoteInfo>
                                            {translate('sections.opponent.player.last-updated')}:&nbsp;{dateTimeTranslate(translate, n.LastUpdatedDate)}
                                        </StyledNoteInfo>
                                    </ReportCard>
                                </div>
                            ))}
                        </StyledReportNotes>
                    )}
                    {Object.keys(data).length === 0 && showNoneIfNoTippingNotes && <>{translate('sections.opponent.player.no-tipping-data')}</>}
                </>
            )}
        </div>
    );
};

TippingPlayer.propTypes = {
    playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    player: PropTypes.shape({}),
    data: PropTypes.arrayOf(PropTypes.object),
    showNoneIfNoTippingNotes: PropTypes.bool,
};

TippingPlayer.defaultProps = {
    player: null,
    data: undefined,
    showNoneIfNoTippingNotes: true,
};

export default TippingPlayer;
